export const reducer = (state, action) => {
  switch (action.type) {
    case "REFRESH":
      return {
        ...state,
        refresh: state.refresh + 1,
      };
    case "STATE":
      return {
        ...state,
        ...action.data,
      };
    case "REGISTER":
      return {
        ...state,
        register: {
          ...state.register,
          ...action.data,
        },
      };

    default:
      return state;
  }
};
